module.exports = __webpack_public_path__ + "img/117-Seidengrau - Gris Dune.jpg";